import React from 'react';
import { Stack, IconButton, Divider, Grid, Row, Col } from 'rsuite';
import { useNavigate } from 'react-router-dom';
import PageContent from '@/components/PageContent';
import PagePreviousIcon from '@rsuite/icons/PagePrevious';
import { AdvanceShareTemplate, AdvanceShareTemplateStatusList } from '@/models/advance-share-template.model';
import { jsDateToZone } from '@/utils/date-time';

interface AdvanceShareTemplateFormProps {
  formObject?: AdvanceShareTemplate;
};

const AdvanceShareTemplateForm: React.FC<AdvanceShareTemplateFormProps> = ({ formObject }) => {
  const nav = useNavigate();

  const statusLabel = formObject ? AdvanceShareTemplateStatusList.findLast(s => s.value == formObject.status)?.label : '';

  return (
    <PageContent>
      <Grid w='100%' fluid>
        <Row justifyContent="center">
          <Col span={{ xs: 24, xl: 12 }}>
            <div style={{ marginBottom: 16 }}>
              <label style={{ fontWeight: 'bold', display: 'block', marginBottom: 4 }}>Name</label>
              <div>{formObject?.name ?? '-'}</div>
            </div>
          </Col>
          <Col span={{ xs: 24, xl: 12 }}>
            <div style={{ marginBottom: 16 }}>
              <label style={{ fontWeight: 'bold', display: 'block', marginBottom: 4 }}>User</label>
              <div>{formObject?.user ? `${formObject?.user?.firstName} ${formObject?.user?.lastName}` : '-'}</div>
            </div>
          </Col>
        </Row>
        <Row justifyContent="center">
          <Col span={{ xs: 24, xl: 12 }}>
            <div style={{ marginBottom: 16 }}>
              <label style={{ fontWeight: 'bold', display: 'block', marginBottom: 4 }}>Version</label>
              <div>{formObject?.version ?? '-'}</div>
            </div>
          </Col>
          <Col span={{ xs: 24, xl: 12 }}>
            <div style={{ marginBottom: 16 }}>
              <label style={{ fontWeight: 'bold', display: 'block', marginBottom: 4 }}>Status</label>
              <div>{statusLabel}</div>
            </div>
          </Col>
        </Row>
        <Row justifyContent="center">
          <Col span={{ xs: 24, xl: 12 }}>
            <div style={{ marginBottom: 16 }}>
              <label style={{ fontWeight: 'bold', display: 'block', marginBottom: 4 }}>Bookmark Count</label>
              <div>{formObject?.bookmarkCount ?? 0}</div>
            </div>
          </Col>
          <Col span={{ xs: 24, xl: 12 }}>
            <div style={{ marginBottom: 16 }}>
              <label style={{ fontWeight: 'bold', display: 'block', marginBottom: 4 }}>Created At</label>
              <div>{jsDateToZone(formObject?.createdAt)}</div>
            </div>
          </Col>
        </Row>
        <Row justifyContent="center">
          <Col span={24}>
            <div style={{ marginBottom: 16 }}>
              <label style={{ fontWeight: 'bold', display: 'block', marginBottom: 4 }}>Document JSON</label>
              <pre style={{ background: '#f5f5f5', padding: 16, borderRadius: 4, maxHeight: 400, overflow: 'auto', fontSize: 12 }}>
                {formObject?.documentJson ? (() => { try { return JSON.stringify(JSON.parse(formObject.documentJson), null, 2); } catch { return formObject.documentJson; } })() : '-'}
              </pre>
            </div>
          </Col>
        </Row>
      </Grid>

      <Divider />
      <Stack justifyContent="flex-start">
        <IconButton icon={<PagePreviousIcon />} onClick={() => nav(-1)}>
          Back
        </IconButton>
      </Stack>
    </PageContent>
  );
};

export default AdvanceShareTemplateForm;
